export default "__VITE_ASSET__CONfA0$w__"